import {Injectable} from '@angular/core';
import {CookieService} from '@app/modules/shared/services/cookie.service';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ClassroomStateModel} from '@app/state/classroom-state.service';
import * as RoomState from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {DiagnosticsRecord} from '@app/models/diagnostics-record';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DiagnosticsService {

  private readonly DIAGNOSTICS_COOKIE_NAME: string = 'diagnostics-passed';
  private classroom: ClassroomStateModel;

  constructor(
      private cookieService: CookieService,
      private http: HttpClient,
      private store: Store
  ) {
    this.store.select(RoomState.ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
  }

  public get passed(): boolean {
    const diagnosticsCookie = this.cookieService.get(this.DIAGNOSTICS_COOKIE_NAME);
    return !!diagnosticsCookie;
  }

  public updateDiagnosticsState(): void {
    //called from "onAppBeforeInitialization" when activatedRoute cannot be used...
    if (this.isComingFromDiagnostics()) {
      this.setPassed();
    }
  }
  public isComingFromDiagnostics(): boolean {
    const url: URL = new URL(window.location.href);
    const passedParam: string | null = url.searchParams.get('diagnostics');
    return passedParam === 'passed';
  }

  public setPassed(): void {
    this.http.get(`${this.classroom.vcrURL}/app/diagnostics/passed`, { withCredentials: true }).subscribe();
  }

  public createRecord(): Observable<object> {
    return this.http.post(`${this.classroom.vcrURL}/app/diagnostics/record`, null);
  }

  public writeDiagnosticsInfo(recordId: number, info: string){
    return this.http.post(`${this.classroom.vcrURL}/app/diagnostics/record/${recordId}/info`, info);
  }

  public getDiagnosticsRecords(page: number, username: string, time: number): Observable<DiagnosticsRecord[]> {
    return this.http.get(`${this.classroom.vcrURL}/app/diagnostics/record`, {
      params: {
        page, username, time
      }
    }).pipe(map((result: any): DiagnosticsRecord[] => {
      return result.data;
    }));
  }
}
